import { forwardRef, HTMLAttributes } from 'react'
import { cn } from '@utils'

type OmpCardProps = HTMLAttributes<HTMLDivElement> & {
  as?: 'div' | 'section' | 'article'
  padded?: boolean
}

const OmpCard = forwardRef<HTMLDivElement, OmpCardProps>(
  ({ as: Tag = 'div', padded = true, className, children, ...rest }, ref) => {
    return (
      <Tag ref={ref as any} className={cn('omp-card', padded && 'omp-card-padded', className)} {...rest}>
        {children}
      </Tag>
    )
  }
)

OmpCard.displayName = 'OmpCard'

export default OmpCard
